import Event from './Event.js'

class TradeCost extends Event {
  get trade_relation(){
    if (this.id === undefined){ return null }

    return this.constructor.employeeStore.event_relations.find(rel => (rel.child_id === this.id) && (rel.parent_type === 'Trade')) || {}
  }
  get trade_id(){
    if (this._trade_id) { return this._trade_id }
    if (this.trade_relation === null) { return null }

    this.trade_id = this.trade_relation.parent_id
    return this._trade_id
  }
  set trade_id(value){
    this._trade_id = value
  }
  get trade(){
    if(this.trade_id){
      return this.constructor.employeeStore.events.find(ev => ev.id === this.trade_id)
    } else {
      return {}
    }
  }
  get value_aep(){
    return this.fractional_value||0
  }
  get value_sf(){
    return (this.value||0)-this.value_aep
  }

  get trade_cost_cancel(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='TradeCostCancel'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get trade_cost_expected(){
    return (this.trade_cost_cancel||{}).trade_cost_expected
  }

  get linked(){
    return this.trade_cost_cancel != null
  }

  // 1. If the trade has manual_value => then it doesn't need a status text
  // 2. If the traded issue has the require_trade_expected field set to true => then it needs a status text
  get should_be_linked() {
    return this.manual_value !== true && this.issue?.require_trade_expected
  }

}
export default TradeCost
